import { render, staticRenderFns } from "./upPayPwd.vue?vue&type=template&id=ca8b8f96&scoped=true"
import script from "./upPayPwd.vue?vue&type=script&lang=js"
export * from "./upPayPwd.vue?vue&type=script&lang=js"
import style0 from "./upPayPwd.vue?vue&type=style&index=0&id=ca8b8f96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b8f96",
  null
  
)

export default component.exports